/**
 * 详细的reducer文件
 */
import { CHANGE_REACHBOTTOM,CHANGE_LOADALLDATA,CHANGE_ERRORCODE,CHANGE_LOADING } from "../actionTypes";

const initialState = {
    isReachBottom:false, //是否触底态
    isLoadAllData:true, // 是否加载完全部数据
    errorCode:'', // 异常码
    loading:true, // 是否展示加载中...
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CHANGE_REACHBOTTOM: {
            const { isReachBottom } = action.payload;
            return {
                ...state,
                isReachBottom
            }
        }
        case CHANGE_LOADALLDATA: {
            const { isLoadAllData } = action.payload;
            return {
                ...state,
                isLoadAllData
            }
        }
        case CHANGE_ERRORCODE: {
            const { errorCode } = action.payload;
            return {
                ...state,
                errorCode
            }
        }
        case CHANGE_LOADING: {
            const { loading } = action.payload;
            return {
                ...state,
                loading
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/localState.js